import { SortDirection } from './parcelSearch';
import { FmtpUserInfo } from './requestHeader';
import { TemplateTypes } from './templates';

export type ShippingPortalParcel = {
    id: string;
    manifest: ShippingPortalManifest | null;
    tentativeManifestNumber?: string;
    parcelNumber: string;
    destination: ShippingPortalLocation;
    origin: ShippingPortalLocation;
    weight: number;
    weightUnit: string;
    reference: string;
    shippingType: ShippingLabelTypes;
    fmtpCustomerId: string;
    tvCustomerName?: string;
    hazardous: string;
    partNumber: string;
    numberOfPieces: number;
    labelSize: ShippingPortalLabelSizes;
    parcelType: string;
    createdBy: string;
    createdOn: string;
    modifiedBy?: string;
    modifiedOn?: string;
    isDeleted?: boolean;
};

export type ShippingPortalParcelWithLocationsAsIds = Omit<
    ShippingPortalParcel,
    'destination' | 'origin'
> & {
    destination?: ShippingPortalLocation;
    origin?: ShippingPortalLocation;
    destinationId: string;
    originId: string;
};

export type ShippingPortalLocation = {
    id: string; //D365 ID
    locationCode: string;
    LNumber?: string;
    name: string;
    city: string;
    state: string;
    street: string;
    zip: string;
    fmtpCustomerId: string;
    dockCode?: string; // This is a legacy field to facilitate LT1. We should move to remove this when LT1 is sunset
    sortCode?: string;
    tvLocationCode?: string; //LNumber
    tvCustomerName?: string;
};

export type ShippingPortalManifest = {
    manifestId: string;
    fmtpCustomerId: string;
    shippingType: ShippingLabelTypes;
    manifestNumber: string;
    note: string;
    departureDate: string;
    destination: ShippingPortalLocation;
    origin: ShippingPortalLocation;
    parcels?: ShippingPortalParcel[];
    numberOfParcels?: number;
    tvCustomerName?: string;
    createdBy: string;
    createdOn: string;
    modifiedBy?: string;
    modifiedOn?: string;
    isDeleted?: boolean;
};

export type ShippingPortalSortOrder = {
    column: ShippingPortalSortingOptions;
    order: SortDirection;
};

export interface ShippingPortalFilters {
    sortOrder: ShippingPortalSortOrder;
    manifestNumber?: string;
    parcelNumber?: string;
    reference?: string;
    origin?: string;
    destination?: string;
    createdBy?: string;
    createdOn?: string;
    departureDate?: string;
    shipmentDate?: string;
    pageSize: number;
    type: ShippingLabelTypes;
    customerFmtpId?: string | null;
    unmanifested?: boolean;
    id?: string;
    ids?: string[];
    manifestId?: string;
    fmtpCustomerId?: string;
    skip?: number;
    userInfo?: FmtpUserInfo;

    // For v2 Parcel Search
    parcelNumbers?: string[];
    startDate?: Date;
    endDate?: Date;
    partNumber?: string;
}

export type ShippingPortalPrintItem = {
    type: 'manifest' | 'label';
    id: string;
    includeAllLabels?: boolean;
    excludeManifest?: boolean;
};

export enum ShippingLabelTypes {
    Return = 'return',
    Outbound = 'outbound',
    Transfer = 'transfer',
}

export enum ShippingPortalLabelSizes {
    SMALL = 'Small 2x4',
    MEDIUM = 'Medium 3x5',
    LARGE = 'Large 4x6',
}

export enum ShippingPortalSortingOptions {
    manifestNumber = 'manifestNumber',
    origin = 'origin',
    destination = 'destination',
    createdBy = 'createdBy',
    createdOn = 'createdOn',
    departureDate = 'departureDate',
}

export type ShippingPortalFavorite = {
    labelQuantity: number;
    dealerCount: number;
    name: string;
    parcelsToPrint: ShippingPortalParcel[];
    isDeleted?: boolean;
};

export type ShippingPortalFavoriteFilters = {
    userId: string;
    templateId?: string;
    type: TemplateTypes.OutboundFavorites;
};
